import { DataModel } from "@toolpad/core/Crud";

import { IUserDto } from "../generated/api-client";
import { nameof } from "../utils/object.utils";
import MagicCrud, { MagicCrudFields } from "../components/MagicCrud";

type UserDtoDataModel = IUserDto & DataModel;

export default function AppUsersPage() {
  const columns: MagicCrudFields<IUserDto>[] = [
    {
      field: nameof<IUserDto>("id"),
      type: "number",
      extraType: "guid",
    },
    {
      field: nameof<IUserDto>("name"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("lastName"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("email"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("isActive"),
      type: "boolean",
    },
    {
      field: nameof<IUserDto>("phoneNumber"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("postalCode"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("country"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("city"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("address"),
      type: "string",
    },
    {
      field: nameof<IUserDto>("isTester"),
      type: "boolean",
    },
    {
      field: nameof<IUserDto>("updateDate"),
      type: "dateTime",
      editable: false,
    },
  ];

  return (
    <MagicCrud<UserDtoDataModel>
      name="appUser"
      apiUrl="users/app"
      columns={columns}
      appUrl="/app-users"
    />
  );
}
